import { MyContext } from 'Context';
import { getLocalStorageItem, setLocalStorageItem } from 'hooks';
import { useUnreadUserApiMutation } from 'queries/Patient';
import { useContext, useEffect } from 'react';

const MessageUserHandlerService = () => {
  const { mutate: unreadMessageUser } = useUnreadUserApiMutation();
  const { data: newMessageData } = useContext(MyContext);
  const currentTime = new Date();
  const userDetails = getLocalStorageItem('roles');

  const getTimeDifferenceInMinutes = (created_at: string): number => {
    const createdAtTime = new Date(created_at);
    return (currentTime.getTime() - createdAtTime.getTime()) / 1000 / 60;
  };

  const relevantChannels = newMessageData.filter((item: any) =>
    item.id.includes('!members-')
  );

  const transformedChannels = relevantChannels.reduce(
    (
      acc: any[],
      channel: { state: { messageSets: never[]; members: any } }
    ) => {
      const messageSets = channel.state?.messageSets || [];
      const filteredMessageSets = messageSets.filter(
        (set: any) =>
          set?.messages?.length === 1 &&
          getTimeDifferenceInMinutes(set.messages[0].created_at) >= 5
      );

      if (filteredMessageSets.length > 0) {
        const members = Object.values(channel.state.members || {});
        const filteredMembers = members.filter(
          ({ user }: any) => user?.id !== userDetails?.uuid
        );
        const memberDetails = filteredMembers.reduce(
          (detailAcc: any, { user }: any) => {
            // eslint-disable-next-line no-param-reassign
            detailAcc[user.id] = user;
            return detailAcc;
          },
          {}
        );

        acc.push({
          ...channel,
          state: {
            ...channel.state,
            messageSets: filteredMessageSets,
            members: memberDetails,
          },
          filteredUsers: filteredMembers.map(({ user }: any) => user),
        });
      }

      return acc;
    },
    []
  );

  const unmatchedUserIds = transformedChannels.flatMap((channel: any) =>
    Object.values(channel.state.members || {})
      .filter(({ id }: any) => id !== userDetails.uuid)
      .map(({ id }: any) => id)
  );

  setLocalStorageItem('unmatchedUserIds', unmatchedUserIds);

  const callUnreadMessageUser = () => {
    const storedUnmatchedUserIds =
      getLocalStorageItem('unmatchedUserIds') || '[]';
    const payload = {
      data: {
        userUuids: storedUnmatchedUserIds,
      },
    };

    if (storedUnmatchedUserIds.length > 0) {
      unreadMessageUser(payload, {
        onSuccess: () => {
          // console.log('API called successfully.');
        },
        onError: (error) => {
          // console.error('Error calling API', error);
        },
      });
    }
  };

  useEffect(() => {
    callUnreadMessageUser();
    const intervalId = setInterval(callUnreadMessageUser, 300000);
    return () => clearInterval(intervalId);
  }, []);

  // Logging
  // console.log(transformedChannels, 'transformedChannels');
  // console.log(unmatchedUserIds, 'unmatchedUserIds');

  return null;
};

export default MessageUserHandlerService;
